/**
 * SSE parser ported verbatim from the mobile app's createSseParser
 * (packages/ai-scheduling-assistant-mobile-platform/src/features/poc-chat/
 * use-poc-send-message-streamed.ts:133). Same parser the rest of the
 * Orion clients use; keeping it in sync avoids divergence on edge cases
 * (multi-byte boundaries, \r\n line endings, missing trailing blank).
 */

export function createSseParser(onEvent: (eventName: string, dataJson: string) => void) {
  let buffer = '';
  let currentEvent = 'message';
  let dataLines: string[] = [];

  const dispatch = () => {
    if (dataLines.length > 0) {
      onEvent(currentEvent, dataLines.join('\n'));
    }
    currentEvent = 'message';
    dataLines = [];
  };

  const consumeLine = (line: string) => {
    if (line === '') {
      dispatch();
      return;
    }
    if (line.startsWith(':')) return; // SSE comment
    const colonIdx = line.indexOf(':');
    if (colonIdx === -1) return;
    const field = line.slice(0, colonIdx);
    let value = line.slice(colonIdx + 1);
    if (value.startsWith(' ')) value = value.slice(1);
    if (field === 'event') {
      currentEvent = value;
    } else if (field === 'data') {
      dataLines.push(value);
    }
  };

  return {
    push(fragment: string) {
      buffer += fragment;
      for (let idx = buffer.search(/\r?\n/); idx >= 0; idx = buffer.search(/\r?\n/)) {
        const line = buffer.slice(0, idx);
        buffer = buffer.slice(idx + (buffer[idx] === '\r' ? 2 : 1));
        consumeLine(line);
      }
    },
    flush() {
      if (buffer.length > 0) {
        consumeLine(buffer);
        buffer = '';
      }
      dispatch();
    },
  };
}
